<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="6" lg="5">
        <v-card class="rounded-xl pa-2" elevation="4">
          <v-card-text class="text-center pa-6">

            <!-- Cargando -->
            <div v-if="loading">
              <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
              <p class="mt-4 grey--text">Confirmando tu pago…</p>
            </div>

            <!-- Aún procesando -->
            <div v-else-if="state === 'pending'">
              <v-icon color="orange" size="56">mdi-clock-outline</v-icon>
              <h2 class="text-h6 font-weight-bold mt-3">Estamos confirmando tu pago</h2>
              <p class="grey--text mt-2">Esto puede tardar unos segundos. Actualiza en un momento.</p>
              <v-btn color="primary" class="mt-2" :loading="loading" @click="load">Actualizar</v-btn>
            </div>

            <!-- Éxito -->
            <div v-else-if="state === 'ok'">
              <v-icon color="green" size="56">mdi-check-circle</v-icon>
              <h2 class="text-h5 font-weight-bold mt-3">¡Bienvenido a Plan2Sell!</h2>
              <p class="grey--text mt-1">
                Tu plan <b>{{ data.plan }}</b> está activo por {{ data.days_remaining }} días.
              </p>

              <v-alert v-if="data.password" color="primary" text class="text-left mt-4 rounded-lg">
                <div class="text-caption font-weight-bold mb-1">TUS DATOS DE ACCESO</div>
                <div class="d-flex align-center">
                  <div>
                    <div class="text-caption grey--text">Usuario (correo)</div>
                    <div class="font-weight-medium">{{ data.email }}</div>
                  </div>
                </div>
                <div class="d-flex align-center mt-2">
                  <div>
                    <div class="text-caption grey--text">Contraseña</div>
                    <div class="font-weight-medium" style="font-family: monospace; font-size: 1.1rem;">{{ data.password }}</div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn small icon @click="copyPassword" title="Copiar"><v-icon small>mdi-content-copy</v-icon></v-btn>
                </div>
                <div class="text-caption orange--text text--darken-2 mt-3">
                  ⚠️ Guárdala ahora: por seguridad solo se muestra esta vez. Cámbiala al iniciar sesión.
                </div>
              </v-alert>

              <!-- Usuario que ya existía: renovación -->
              <v-alert v-else-if="!data.is_new_user" color="green" text class="text-left mt-4 rounded-lg">
                <div class="text-caption font-weight-bold mb-1">CUENTA RENOVADA</div>
                Renovamos tu suscripción para <b>{{ data.email }}</b>. Ingresa con tu contraseña habitual.
              </v-alert>

              <!-- Nuevo usuario que recargó: la clave ya se mostró una vez -->
              <v-alert v-else color="blue" text class="text-left mt-4 rounded-lg">
                <div class="text-caption font-weight-bold mb-1">CUENTA CREADA — {{ data.email }}</div>
                Tu contraseña ya se mostró una sola vez. Si la guardaste, inicia sesión.
                Si la perdiste, escríbenos a <a href="mailto:contacto@year2day.com">contacto@year2day.com</a>.
              </v-alert>

              <v-btn color="primary" large block class="mt-4 rounded-lg" @click="goLogin">
                Iniciar sesión <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </div>

            <!-- No encontrado / error -->
            <div v-else>
              <v-icon color="red" size="56">mdi-alert-circle</v-icon>
              <h2 class="text-h6 font-weight-bold mt-3">No pudimos encontrar tu compra</h2>
              <p class="grey--text mt-2">
                Si ya pagaste, escríbenos a
                <a href="mailto:contacto@year2day.com">contacto@year2day.com</a> con tu comprobante.
              </p>
              <v-btn text color="primary" href="https://plan2sell.cl">Volver al inicio</v-btn>
            </div>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from '../plugins/axios'

export default {
  name: 'WelcomeView',
  data() {
    return {
      loading: true,
      state: null, // 'ok' | 'pending' | 'error'
      data: {},
    }
  },
  methods: {
    async load() {
      const token = this.$route.query.token
      if (!token) { this.state = 'error'; this.loading = false; return }
      this.loading = true
      try {
        const res = await axios.get('/billing/checkout/status/', { params: { token } })
        if (res.data.status === 'ok') {
          this.data = res.data
          this.state = 'ok'
        } else if (res.data.status === 'pending') {
          this.state = 'pending'
        } else {
          this.state = 'error'
        }
      } catch (e) {
        this.state = 'error'
      }
      this.loading = false
    },
    copyPassword() {
      navigator.clipboard && navigator.clipboard.writeText(this.data.password)
      this.$toast && this.$toast.success('Contraseña copiada')
    },
    goLogin() {
      this.$router.push('/login')
    },
  },
  created() {
    this.load()
  },
}
</script>
